import script from "./IonModalNoScrollContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./IonModalNoScrollContent.vue?vue&type=script&setup=true&lang=ts"

import "./IonModalNoScrollContent.vue?vue&type=style&index=0&id=d5c92e1e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5c92e1e"]])

export default __exports__